import { Button, PlaceholderSegment } from '@britishcouncil/react-admin';
import { Centered } from 'components';
import { ROUTING_PATHS } from 'const';
import { useAllowedActions, useNavigationContext } from 'hooks';
import { Link, generatePath } from 'react-router';
import { Icon } from 'semantic-ui-react';

export const NoPlannedSessionsPlaceholder = () => {
  const { locationName } = useNavigationContext();
  const { createSpeakingSession } = ROUTING_PATHS;
  const { canCreateSpeakingSession } = useAllowedActions();

  return (
    <Centered>
      <PlaceholderSegment
        icon="comment"
        color="grey"
        title={`${locationName} has no Speaking sessions planned.`}
        description={
          canCreateSpeakingSession ? 'Would you like to create a new session?' : undefined
        }
        data-testid="no-planned-sessions-placeholder"
      >
        {canCreateSpeakingSession && (
          <Link
            to={generatePath(createSpeakingSession.absolutePath)}
            data-testid="create-speaking-session-link"
          >
            <Button primary compact>
              <Icon name="plus square" />
              Create
            </Button>
          </Link>
        )}
      </PlaceholderSegment>
    </Centered>
  );
};
